var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_9600_1969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.16602 10.0013V3.33464C4.16602 2.41416 4.91221 1.66797 5.83268 1.66797H14.166C15.0865 1.66797 15.8327 2.41416 15.8327 3.33464V10.0013",
    stroke: "#062D60",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.91602 8.33333H12.0827M7.91602 5H12.0827",
    stroke: "#062D60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.8327 5.83203L18.0886 8.08796C18.2448 8.24423 18.3327 8.4562 18.3327 8.6772V16.6654C18.3327 17.5859 17.5865 18.332 16.666 18.332H3.33268C2.41221 18.332 1.66602 17.5859 1.66602 16.6654V8.6772C1.66602 8.4562 1.75382 8.24423 1.91009 8.08796L4.16602 5.83203",
    stroke: "#062D60",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.3327 8.33203L10.7447 12.126C10.2755 12.3606 9.72318 12.3606 9.25402 12.126L1.66602 8.33203",
    stroke: "#062D60",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9600_1969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ea3d307465e5dd1bfa01e9314f4a3f03.svg";
export { ForwardRef as ReactComponent };